// Keep in sync with backend get_accepted_subdivision_types in
// project/engine/check_definitions/claim_types/position_location.py
export const SUBDIVISION_KEYS_GB = [
  "Country",
  "Province",
  "State",
  "Territory",
];

export const SUBDIVISION_KEYS_ALL = [
  "Country",
  "Province",
  "State",
  "Territory",
  "District",
  "Union territory",
  "Capital territory",
  "Outlying area",
  "Metropolitan city",
  "Autonomous region",
  "Autonomous province",
  "Free municipal consortium",
  "Decentralized regional entity",
];

// FR-1158: Russia-only extras. Do not add these to SUBDIVISION_KEYS_ALL —
// "Republic" would give UA/UZ a 1-option dropdown (same class as FR-232).
export const SUBDIVISION_KEYS_RU_EXTRA = [
  "Administrative region",
  "Republic",
  "Administrative territory",
  "Autonomous district",
  "Autonomous city",
];

export function getSubdivisionKeys(country?: string): string[] {
  if (country === "GB") {
    return SUBDIVISION_KEYS_GB;
  }
  if (country === "RU") {
    return [...SUBDIVISION_KEYS_ALL, ...SUBDIVISION_KEYS_RU_EXTRA];
  }
  return SUBDIVISION_KEYS_ALL;
}
